// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--8aefb";
export var footerLeft = "index-module--footer-left--5bbd4";
export var footerRight = "index-module--footer-right--a2e05";
export var prepared = "index-module--prepared--28e48";
export var preparing = "index-module--preparing--64647";
export var rotate = "index-module--rotate--e4017";